import { ASSOCIATION_MAP, AssociationDirection, AssociationType } from '../constants';
import { ObjectType } from '../tokens-and-interfaces';

export function getAssociationType(fromObject: ObjectType, toObject: ObjectType): AssociationType {
  return ASSOCIATION_MAP.get(fromObject)?.get(toObject) ?? AssociationType.Invalid;
}

export function getAssociationDirection(
  objectType: ObjectType,
  associationType: AssociationType,
): AssociationDirection {
  const objects = associationType.split('-');
  const fromObject = objects[0];
  const toObject = objects[1];
  if (fromObject === objectType) {
    return AssociationDirection.From;
  } else if (toObject === objectType) {
    return AssociationDirection.To;
  }
  return AssociationDirection.Invalid;
}
